import { httpMobile } from "@/utils/httpMobile"

export type ServiceStaffResponse = {
  
  "code": string // "100",
  "message": string // "",
  "action_time": number // 1721716764,
  "data": {
    "staff": Array<{
      "name": string // "飒飒",
      "value": number // 490
    }>
  }
}



export const serviceStaffMobile = async ()=>{
  return httpMobile.post<ServiceStaffResponse>(`/api.php?c=ClientManager&a=getStaffList`,{c:"ClientManager",a:"getStaffList"})
}